import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "48",
  height: "48",
  viewBox: "0 0 48 48",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("rect", {
  width: "48",
  height: "48",
  rx: "8",
  fill: "#00ADEF"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  d: "M29.248 29.9924C12.9493 26.145 8 13 8 13C8 13 19.9467 22.1374 29.248 21.3359C31.9325 21.1045 34.962 19.9827 37.6107 20.4542C39.2402 20.7443 40 21.8969 40 21.8969C40 21.8969 38.5985 22.7005 37.8667 23.7405C34.5387 28.4695 31.345 30.4874 29.248 29.9924Z",
  fill: "white"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("path", {
  d: "M22.4213 28.8702L13.0347 29.5104C13.0347 29.5104 19.776 30.4733 20.1173 34C20.1173 34 20.7599 33.4379 22.4213 32.7176C24.1835 31.9536 28.224 30.9542 28.224 30.9542C24.0427 29.9924 23.104 29.271 22.4213 28.8702Z",
  fill: "white"
}, null, -1)
const _hoisted_5 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4
]

import { withDefaults } from 'vue';
      
      interface IProps {
        color?: string;
      }
      
      
export default /*#__PURE__*/_defineComponent({
  __name: 'BlueBirdIcon',
  props: {
    color: {}
  },
  setup(__props: any) {

      const props = __props;
      
return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_5))
}
}

})